'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function AmindSubTheme(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M288 704H192a64 64 0 0 1-64-64V320a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64h448a64 64 0 0 1 64 64v96a64 64 0 0 1-64 64H192v288a32 32 0 0 0 32 32h64v-64a64 64 0 0 1 64-64h544a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64v-160z m96-128a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h480a32 32 0 0 0 32-32v-224a32 32 0 0 0-32-32H384z' })
  );
}
AmindSubTheme.displayName = 'AmindSubTheme';

module.exports = AmindSubTheme;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/amindSubTheme.js
// module id = 147
// module chunks = 0